import moment from "moment";

export function convertTo24Hour(time12h: any) {
  if (!time12h) return;

  const [time, modifier] = time12h.split(" ");

  let [hours, minutes] = time.split(":");

  if (hours === "12" && modifier === "AM") {
    hours = "00";
  }

  if (modifier === "PM") {
    hours = Number.parseInt(hours, 10) + 12;
  }

  return `${hours}:${minutes}`;
}

export function convertTo12Hour(time24h: any) {
  if (!time24h) return;

  // Remove the seconds and trailing zeros
  const timeWithoutSeconds = time24h.replace(/:00$/, "");

  let [hours, minutes] = timeWithoutSeconds.split(":");
  let modifier = "AM";

  if (hours >= 12) {
    modifier = "PM";
    if (hours > 12) {
      hours -= 12;
    }
  }

  if (hours === "00") {
    hours = "12";
  }

  return `${hours}:${minutes} ${modifier}`;
}

export function removeSecondsFromTime(time24h: any) {
  if (!time24h) return;

  const [hours, minutes] = time24h.split(":");
  return `${hours}:${minutes}`;
}

export function formatDateTime(dateStr: string): string {
  // Parse the date string
  const date = moment(dateStr);

  // Format the date and time
  const formattedDate = date.format("DD-MM-YYYY HH:mm:ss");

  return formattedDate;
}
